import { render, staticRenderFns } from "./CampaignTab.vue?vue&type=template&id=3618fa46&scoped=true&"
import script from "./CampaignTab.vue?vue&type=script&lang=ts&"
export * from "./CampaignTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618fa46",
  null
  
)

export default component.exports